

























import {
	defineComponent,
} from '@vue/composition-api';
import IconButton from '../buttons/IconButton.vue';
import { Size } from '../constants';
import SimpleDropdown from './SimpleDropdown.vue';

export default defineComponent({
	components: {
		SimpleDropdown,
		IconButton,
	},
	props: {
		isOpen: {
			type: Boolean,
			required: true,
		},
		openedAriaLabel: {
			type: String,
			required: true,
		},
		closedAriaLabel: {
			type: String,
			required: true,
		},
	},
	setup() {
		return {
			Size,
		};
	},
});
